import React from 'react';
import { Box, TextButton, Avatar, Text, StarsRatingBar } from '@wix/design-system';
import s from './MarketPlaceBriefWidget.module.scss';
export const MarketPlaceBriefWidget = _ref => {
  let {
    data: {
      partners
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    className: s.container
  }, partners.map(partner => /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "12px"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: s.avatar,
    size: "size60",
    color: "A1",
    name: partner.name,
    imgProps: {
      src: partner.profilePhoto
    }
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    dataHook: "partner-box-name",
    weight: "bold",
    ellipsis: true
  }, partner.name)), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    dataHook: "partner-box-rating-mobile",
    direction: "horizontal",
    gap: 1,
    minWidth: "165px"
  }, /*#__PURE__*/React.createElement(StarsRatingBar, {
    dataHook: "partner-box-stars-rating",
    size: "small",
    value: Math.round(partner.reviewsScore),
    readOnly: true
  }), /*#__PURE__*/React.createElement(Text, {
    dataHook: "partner-box-reviews",
    tagName: "div",
    size: "small",
    secondary: true,
    weight: "thin"
  }, `${partner.reviewsScore.toFixed(1)} (${partner.reviewsCount || 0})`)), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 1
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: "partner-box-projects",
    tagName: "div",
    size: "small",
    secondary: true,
    weight: "thin"
  }, partner.projectsCount, " Projects"))), /*#__PURE__*/React.createElement(Text, {
    tagName: "div",
    size: "small",
    secondary: true,
    weight: "thin",
    ellipsis: true
  }, partner.description)))), /*#__PURE__*/React.createElement(TextButton, {
    href: "https://www.wix.com/marketplace/hire",
    className: s.more
  }, "Explore more"));
};
export const PARTNERS_MARKETPLACE_BRIEF_WIDGET = 'PARTNERS_MARKETPLACE_BRIEF_WIDGET';

/** type ToolExecuteResponse.WidgetSpec (Assistant tool that respond with widget) example:
 *
 * widget: {
    widget: 'PARTNERS_MARKETPLACE_BRIEF_WIDGET',
    data: {
      serviceId: 'service-id',
      partners: [{
        { "name": "Partner 1", "profilePhoto": "https://wixmp-cca7fdc52d9b9ae8ca79a86d.wixmp.com/marketplace/partners/a8c3d107-04df-4ad2-b55d-1ae0f95a04e5/profile-image/1650969097942/WhatsApp%20Image%202022-03-08%20at%2022.33.53.jpeg", "reviewsCount": 4, "reviewsScore": 2.3, "projectsCount": 34 },
        { "name": "Partner 2", "profilePhoto": "https://wixmp-cca7fdc52d9b9ae8ca79a86d.wixmp.com/marketplace/partners/a8c3d107-04df-4ad2-b55d-1ae0f95a04e5/profile-image/1650969097942/WhatsApp%20Image%202022-03-08%20at%2022.33.53.jpeg", "reviewsCount": 2223, "reviewsScore": 3.3, "projectsCount": 1 }
      }]
    }
  }
*/
//# sourceMappingURL=MarketPlaceBriefWidget.js.map